import { init, backButton, mainButton, viewport, retrieveLaunchParams, } from '@telegram-apps/sdk';
export class TelegramProvider {
    name = 'telegram';
    _user = null;
    tmaUser;
    constructor() {
        init();
        mainButton.mount();
        mainButton.onClick(() => {
            viewport.expand();
            mainButton.setParams({ isVisible: false });
        });
        mainButton.setParams({
            backgroundColor: '#e8008a',
            textColor: '#ffffff',
            text: 'Expand',
            isEnabled: true,
            isVisible: true,
        });
        backButton.mount();
        const off = backButton.onClick(() => {
            off();
            window.history.back();
        });
        const initData = retrieveLaunchParams();
        this.tmaUser = initData?.tgWebAppData?.user;
        this._user = {
            name: this.tmaUser?.first_name,
            profilePictureUrl: this.tmaUser?.photo_url,
        };
    }
    get user() {
        return this._user;
    }
    /* User */
    requestLogin() {
        return this._user ? Promise.resolve(this._user) : Promise.reject();
    }
    get isLoggedIn() {
        return !!this._user;
    }
}
